<template>
    <section class="author-profile-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-12" v-if="media >= 992">

                    <aside class="sidebar sidebar_author">
                        <profile-filter :media="media" :filters="filter" />

                        <profile-tabs :organization="organization"/>

                    </aside>

                </div>
                <div class="col-lg-8 col-md-12">
                    <div class="row">
                        <div class="col-md-12">
                            <organization-about :stats="getterOrganizationStats" />
                        </div>
                    </div>

                    <div class="row" v-if="organization && organization.description">
                        <div class="col-md-12">
                            <organization-description :organization="organization"/>
                        </div>
                    </div>

                    <div class="row" v-if="media < 992">
                        <div class="col-md-12">
                            <profile-filter :media="media"  :filters="filter"/>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <projects :filter="profilePageList" :organization="organization" />
                        </div>
                    </div>

                    <div class="row" v-if="media < 992">
                        <div class="col-md-12">
                            <profile-tabs :organization="organization"/>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    </section>
</template>

<script>
import {mapGetters} from 'vuex'

import ProfileTabs from "./OrganizationProfileTabs";
import OrganizationAbout from "./OrganizationAbout";
import OrganizationDescription from "./OrganizationDescription";
import Projects from "./OrganizationProjects";
import ProfileFilter from "../Profile/ProfileFilter";

export default {
    name: "OrganizationProfile",
    components: {
        ProfileTabs,
        OrganizationAbout,
        OrganizationDescription,
        ProfileFilter,
        Projects,
    },
    props: ['organization'],
    created() {
        this.myEventHandler()

        window.addEventListener("resize", this.myEventHandler);
    },
    destroyed(){
        window.removeEventListener("resize", this.myEventHandler);
    },


    data(){
        return{
            media: null,
            filter: {
                params: [
                    {
                        nameValue: 'actualProjects',
                        title: 'Проектов в реализации',
                        checked: true
                    },
                    {
                        nameValue: 'archivedProjects',
                        title: 'Завершенные проекты',
                        checked: false
                    },
                    {
                        nameValue: 'membersPetsSelf',
                        title: 'Животные сотрудников',
                        checked: false
                    },
                    {
                        nameValue: 'membersPets',
                        title: 'Сотрудники помогают',
                        checked: false
                    }
                ],
                value: 'actualProjects'
            },
            stats: null
        }
    },


    mounted() {},
    computed: {

        ...mapGetters(['getterOrganizationStats']),

        profilePageList(){

            let result = {
                title: '',
                petsType: '',
            }

            switch (this.filter.value){
                case "actualProjects":
                    result.petsType = 'actualProjects';
                    result.title = 'Проектов в реализации';
                    break;
                case "archivedProjects":
                    result.petsType = 'archivedProjects';
                    result.title = 'Завершенные проекты';
                    break;
                case "membersPetsSelf":
                    result.petsType = 'membersPetsSelf';
                    result.title = 'Животные сотрудников';
                    break;
                case "membersPets":
                    result.petsType = 'membersPets';
                    result.title = 'Сотрудники помогают';
                    break;
                default:
                    result.petsType = 'actualProjects';
                    result.title = 'Проектов в реализации';
            }

            return result

        },
    },
    methods:{

        myEventHandler(e){
            this.media = window.innerWidth
        },

    }

}
</script>

<style scoped>

</style>
